'use strict';

var toStream = require('pull-stream-to-stream');

module.exports = function pingReadableStream(self) {
  return function (peerId, opts) {
    return toStream.source(self.pingPullStream(peerId, opts));
  };
};